// extracted by mini-css-extract-plugin
module.exports = {"energy-rating":"energy-rating_energy-rating__I_DK_"};